export enum Location {
  EXTENSION = 'extension',
  DETAILS = 'details',
}
